import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { VmFunctionEditorView } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/vmFunctionEditor/vmFunctionEditor-view";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IReport } from "../IReport";
import { ReportEditorViewModel, ReportInserter, ReportUpdater } from "../reportEditor/reportEditor-viewModel";
import  { ReportManipulationView } from "./reportManipulation-view"

export class ReportManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت گزارشات سیستم ساز';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.reports = ObservableArray.create<report>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation));
        this.refresh()

    }
    GetDefaultView(): View <ViewModel> {
        return new ReportManipulationView();
    }
    public getTypeId(): string {
        return "VM-2121A8F1-60EA-4E59-B2A5-A6F0571062FF"
    }
    public set reports(v: ObservableArray<report>) { this._reports = v; } public get reports(): ObservableArray<report> { return this._reports;} private _reports: ObservableArray<report>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/GetAllReports',{
                FurtherQueryInfo:filteringInformation
            });
            this.reports.update(...result.Reports.map(q=>{
                let r = new report(this);
                r.id = q.Id;
                r.name = q.Name;
                r.path = q.Path;
                r.isReportChanged = false;
                r.content = '';
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new ReportEditorViewModel(this,new ReportInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(report:IReport){
        let popup = new ReportEditorViewModel(this,new ReportUpdater());
        report.cloneTo(popup);
        popup.loadFromServer();
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }

    async delete(report: report) {
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ReportServices/DeleteReportFile',{
                Id : report.id
            });
            if(result.IsSuccessful){
                this.isLoading = false;
                this.refresh();
                this.messageBoxConfirmSuccess('گزارش با موفقیت حذف شد.','عملیات موفق');
            }else{
                this.messageBoxConfirmWarning('خطا در انجام عملیات','حذف ناموفق')
            }
        } catch (ex) {
            this.messageBoxConfirmWarning('خطا در انجام عملیات','حذف ناموفق')
            this.isLoading = false;
            console.log(ex);
        } finally {
        }
    }
    
}

export class report extends ViewModel implements IReport{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReportManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent: ReportManipulationViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set isReportChanged(v: boolean) { this._isReportChanged = v; } public get isReportChanged(): boolean { return this._isReportChanged;} private _isReportChanged: boolean;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    

    public set reportStructure(v: string) { this._reportStructure = v; } public get reportStructure(): string { return this._reportStructure;} private _reportStructure: string;
    public set isReportStructureChanged(v: boolean) { this._isReportStructureChanged = v; } public get isReportStructureChanged(): boolean { return this._isReportStructureChanged;} private _isReportStructureChanged: boolean;
    
    cloneTo(report:IReport){
        report.id = this.id;
        report.name = this.name;
        report.path = this.path;
        report.isReportChanged = this.isReportChanged;
        report.content = this.content;
    }

    edit(){
        this._typedParent.edit(this);
    }

    async delete(){
        let confirm =await this.messageBoxWarningYesNo('آیا از حدف اطمینان دارید؟','حدف گزارش');
        if(confirm=='yes'){
            this._typedParent.delete(this);
        }
    }
}
